import { useCareerSkillDetailQuery } from 'core';

import { transformSkillDetail } from './transform';

/** ТЗ 0039, доводка UX — данные страницы одного навыка. */
export const useSkillDetail = (slug: string) => {
  const { data, loading } = useCareerSkillDetailQuery({
    variables: { slug },
    fetchPolicy: 'cache-and-network',
    // Повторные обращения ЖИВОГО наблюдателя берут из кэша; тот же приём
    // стоит в `useCareerSkillGraph`.
    //
    // ⚠️ Новое ОТКРЫТИЕ паспорта всё равно идёт в сеть: `skip` уничтожает
    // наблюдателя, и следующий монтаж начинает с начальной политики. Это
    // осознанно: прогресс профессий («5 из 12») стоит в одном кадре с картой,
    // и показать его устаревшим хуже, чем сходить за ним ещё раз.
    nextFetchPolicy: 'cache-first',
    skip: !slug,
  });

  return { skill: transformSkillDetail(data), loading };
};
